// Whether a `show_when` rule holds for the values on a form. ONE implementation, imported by the record form (live/RecordForm.jsx) and the public form
// pages (live/PublicFormPage.jsx, which must not import RecordForm: that would pull the signed-in app into a stranger's first download). A rule is
// `{field, op, value}`; no rule, or one with no field, is always visible, and an operator this does not know leaves the field visible.
export function evalShowWhen(rule, values) {
  if (!rule || !rule.field) return true;
  const actual = values[rule.field];
  const target = rule.value;
  const isEmpty = actual === null || actual === undefined || actual === '' || (Array.isArray(actual) && actual.length === 0);
  switch (rule.op || 'eq') {
    case 'empty':     return isEmpty;
    case 'not_empty': return !isEmpty;
    case 'eq':        return String(actual ?? '') === String(target ?? '');
    case 'ne':        return String(actual ?? '') !== String(target ?? '');
    case 'in': {
      const opts = Array.isArray(target) ? target : (target != null ? [target] : []);
      return opts.map(String).includes(String(actual ?? ''));
    }
    default:          return true;
  }
}
